// extracted by mini-css-extract-plugin
module.exports = {"container":"discoverItem-module--container--11e_3","title":"discoverItem-module--title--XIXPO","description":"discoverItem-module--description--3CWtr"};